import router from '@router'
import store from '@state/store'
import Vue from 'vue'
import IdleVue from 'idle-vue'
import App from './app.vue'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// instantiate plugins
import '@plugins/axios'
import '@plugins/moment'
import '@plugins/tel-input'
import '@plugins/google-maps'
import { i18n } from '@plugins/i18n'
import vuetify from '@plugins/vuetify'

// todo: import config from '@config' -> config/index.js which will internally import other configs
// Vue.prototype.$config = config to register it globally and use it like e.g this.API_KEY
// import constants from '@constants'
// Vue.prototype.$constants = constants

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const eventsHub = new Vue()

Vue.use(vuetify)
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 9 * 60 * 1000, // 10 min
  startAtIdle: false,
})
const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
